import { message } from 'antd';
import FooterLogo from 'assets/imgs/svg/new_topbar_logo.svg';
import { flexColumn, flexStyle, vw } from 'components/common/Common';
import dayjs from 'dayjs';
import React, { useReducer } from 'react';
import styled from 'styled-components';
import { regularCheck, setLocalStorage } from 'untils/auth';
import { flexGap } from 'untils/polyfill/flex';
import SuccessfulState from '../coupons/SuccessfulState';

const initForm = {
  isCheck: false,
  email: '',
  ruleEmail: true,
  activityState: false,
};

const NewFooter = styled.footer`
  position: relative;
  color: #fff;
  font-size: ${vw(18)};

  background: #0e142d top right / contain no-repeat url('/imgs/svg/footer-background.svg');
`;

const Max = styled.div`
  max-width: 1380px;
  margin: 0 auto;
  padding: ${vw(16)} ${vw(40)} ${vw(0)} ${vw(40)};
  @media (max-width: 757px) {
    padding: ${vw(16)} ${vw(16)} ${vw(0)} ${vw(16)};
  }
`;

const FullContainer = styled.div`
  ${flexStyle}
  /* display: grid;
  grid-template-columns: 2fr 1fr; */

  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 40px;
  ${flexGap('40px')}

  @media (max-width: 1380px) {
    flex-direction: column-reverse;
  }
`;

const FooterLinkContainer = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));
  ${flexGap('32px')}
  justify-content: space-between;
`;

const FooterLinks = styled.div`
  ${flexColumn}
  ${flexGap('24px')}
`;

const FooterContent = styled.div`
  margin: 16px 0;
  height: 100%;
  width: 100%;
`;

const FooterNavH4 = styled.h4`
  color: rgba(255, 255, 255, 0.5);
  font-size: ${vw(22)};
`;

const FootLink = styled.a`
  cursor: pointer;
  color: rgba(255, 255, 255, 0.85);

  i {
    font-style: normal;
    position: relative;
  }

  &:hover {
    i {
      color: #fff;
      font-weight: 700;

      &::before {
        content: '';
        width: ${vw(24)};
        height: ${vw(24)};
        background-image: url('../../imgs/svg/down_j.svg');
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        transform: rotate(-90deg);
        right: ${vw(-32)};
        top: 50%;
        margin-top: ${vw(-12)};
      }
    }
  }
`;

const SubForm = styled.div`
  width: 520px;
  background: rgba(255, 255, 255, 0.08);
  padding: ${vw(16)} ${vw(24)};
  /* min-width: ${vw(520)}; */
  max-height: 272px;
  @media (max-width: 1380px) {
    width: unset;
  }
`;

const SubFormTitle = styled.h4`
  font-size: ${vw(26)};
  font-weight: 700;
  line-height: ${vw(29)};
  color: #17c7ff;
  margin-bottom: ${vw(8)};
`;

const EmailInputContainer = styled.div`
  margin-top: ${vw(16)};
  margin-bottom: ${vw(16)};
  display: flex;
  ${flexGap('8px')}
  input {
    flex: 1;
    height: ${vw(46)};
    outline: none;
    border: none;
    border-radius: ${vw(8)};
    color: #07080a;
    padding-left: ${vw(16)};
  }
  button {
    width: ${vw(138)};
    height: ${vw(46)};
    border-radius: ${vw(8)};
    background-color: #0063db;
    border: none;
    color: #fff;
    font-size: ${vw(18)};
    font-weight: 700;
    line-height: ${vw(22)};
    cursor: pointer;
  }
  .error-text {
    font-size: ${vw(14)};
    color: #ff4e4b;
    position: absolute;
  }
`;

const AgreementContainer = styled.div`
  display: flex;
  height: ${vw(52)};
  align-items: center;
  p {
    font-size: ${vw(14)};
    color: #fff;
    a {
      display: inline-block;
      margin: 0;
      font-weight: 700;
      text-decoration: underline;
      color: #fff !important;
    }
  }
`;

const Icon = styled.i`
  display: block;
  width: ${vw(24)};
  height: ${vw(24)};
  border-radius: ${vw(4)};
  background-color: transparent;
  border: ${vw(2)} solid rgba(255, 255, 255, 0.2);

  cursor: pointer;
  margin-right: ${vw(16)};
  &.active {
    border-radius: ${vw(4)};
    border: none;
    background-image: url('/imgs/svg/selected.svg');
  }
`;

const Social = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  flex-wrap: wrap;
  padding: 32px 0;

  ${flexGap('24px')}
`;

const SocialIcon = styled.ul`
  display: flex;
  ${flexGap('40px')}
  img {
    width: ${vw(24)};
    height: ${vw(24)};
    cursor: pointer;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  ${flexGap('40px')}
  flex-wrap: wrap;
`;

const LogoInnerSection = styled.div`
  display: flex;
  align-items: center;
  ${flexGap('40px')}
  justify-content: center;
  @media (max-width: 1380px) {
    ${flexGap('8px')}

    flex-direction: column;
  }
`;

const CopyRight = styled.p`
  text-align: center;
  font-size: ${vw(12)};
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.5);
`;
const LogoText = styled.p`
  font-size: ${vw(12)};
  text-decoration: underline;
  text-align: center;
  white-space: nowrap;

  color: rgba(255, 255, 255, 0.5);
`;

const LogoImage = styled.img`
  width: ${vw(144)} !important;
`;

const Separator = styled.hr`
  width: 100vw;
`;

const LegalText = styled.p`
  font-size: ${vw(12)};
  text-align: center;
  color: #fff;
`;

const LegalInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${vw(120)};
  margin-top: ${vw(16)};
`;

const LegalInfoContent = styled.div`
  font-size: ${vw(16)};
`;

const ResponsiveFooter = () => {
  const currentYear = dayjs().format('YYYY');

  const [{ isCheck, email, ruleEmail, activityState }, setState] = useReducer(
    (current, update) => ({
      ...current,
      ...update,
    }),
    initForm
  );

  const onFinish = () => {
    if (!isCheck) {
      return message.warning('Please check Terms and Conditions.');
    }
    if (!email) {
      setState({
        ruleEmail: false,
      });
    }

    setLocalStorage(
      'accountRegister',
      JSON.stringify({
        account: email,
        rcvEmailFlag: 1,
      })
    );
    setState({
      activityState: true,
    });
  };

  return (
    <>
      <NewFooter>
        <Max>
          <FullContainer>
            <FooterLinkContainer>
              <FooterContent>
                <FooterNavH4>Company</FooterNavH4>
                <FooterLinks>
                  <FootLink href="/aboutUs" target="_blank" rel="noreferrer">
                    <i>About Us</i>
                  </FootLink>
                  <FootLink href="/contactUs" target="_blank" rel="noreferrer">
                    <i>Contact Us</i>
                  </FootLink>
                  <FootLink href="/partnerWithUs" target="_blank" rel="noreferrer">
                    <i>Partner With Us</i>
                  </FootLink>
                  <FootLink href="/affiliatePartner" target="_blank" rel="noreferrer">
                    <i>Become an Affiliate Partner</i>
                  </FootLink>
                </FooterLinks>
              </FooterContent>
              <FooterContent>
                <FooterNavH4>Explore</FooterNavH4>
                <FooterLinks>
                  <FootLink href="/charterQuote" target="_blank">
                    <i>Private Charter Flights</i>
                  </FootLink>
                  <FootLink href="/emptyLeg" target="_blank">
                    <i>Empty Leg Flights</i>
                  </FootLink>{' '}
                  <FootLink href="/membership" target="_blank">
                    <i>Private Jet Membership</i>
                  </FootLink>{' '}
                  <FootLink href="/blog" target="_blank">
                    <i>Blog</i>
                  </FootLink>
                </FooterLinks>
              </FooterContent>
              <FooterContent>
                <FooterNavH4>Contact Us</FooterNavH4>
                <FooterLinks>
                  <p>
                    <FootLink href="mailto:charter@airacer.com">charter@airacer.com</FootLink>
                  </p>
                  <p>+1 800-213-5051</p>
                  <FootLink href="/Blog/Media-Kit" target="_blank" rel="noreferrer">
                    <i>Media Kit</i>
                  </FootLink>
                </FooterLinks>
                <FooterContent>
                  <FooterNavH4>Legal</FooterNavH4>
                  <FooterLinks>
                    <FootLink href="/termOfUse" target="_blank">
                      <i>Terms and Conditions</i>
                    </FootLink>
                    <FootLink href="/privacyPolicy" target="_blank">
                      <i>Privacy Policy</i>
                    </FootLink>
                  </FooterLinks>
                </FooterContent>
              </FooterContent>
            </FooterLinkContainer>

            <div>
              <SubForm>
                <SubFormTitle>Get the Latest Updates!</SubFormTitle>
                <EmailInputContainer>
                  <input
                    type="text"
                    value={email}
                    placeholder="Enter Your Email"
                    onChange={(e) => setState({ email: e.target.value })}
                    onBlur={(e) => {
                      if (!e.target.value) return;
                      setState({ ruleEmail: regularCheck('email', e.target.value) });
                    }}
                  />
                  <button onClick={onFinish}>Subscribe</button>
                  {!ruleEmail && (
                    <div className="error-text">Please enter a valid email address</div>
                  )}
                </EmailInputContainer>
                <AgreementContainer>
                  <button
                    onClick={() => {
                      setState({ isCheck: !isCheck });
                    }}
                  >
                    <Icon className={`bg-image ${isCheck ? 'active' : ''}`}></Icon>
                  </button>
                  <p>
                    By subscribing, you agree to subscribe to the Airacer Newsletter, and agree to{' '}
                    <FootLink href="/termOfUse">Terms & Conditions</FootLink> and{' '}
                    <FootLink href="/privacyPolicy">Privacy Policy</FootLink>
                  </p>
                </AgreementContainer>
              </SubForm>
              <div>
                <img
                  style={{ width: 178, height: 61 }}
                  src={'/imgs/svg/logo-nbaa.svg'}
                  alt="logo nbaa"
                  className="logo-nbaa"
                  width={178}
                  height={61}
                />
              </div>
            </div>
          </FullContainer>
        </Max>
        <Separator />
        <Max style={{ paddingBlock: 0 }}>
          <Social>
            <LogoSection>
              <picture>
                <source srcSet={FooterLogo} media="(max-width: 768px)" width={232} height={63} />
                <LogoImage
                  src={require('../../assets/imgs/webp/copyright.webp').default}
                  alt="example"
                  className="footer-logo"
                />
              </picture>
              <LogoInnerSection>
                <LogoText>Ace the way you fly</LogoText>
                <CopyRight>©{currentYear} Airacer Inc. All rights reserved.</CopyRight>
              </LogoInnerSection>
            </LogoSection>
            <SocialIcon>
              <a href="https://www.facebook.com/airacer.inc/" target="_blank" rel="noreferrer">
                <img src="/imgs/svg/icon_Facebook.svg" alt="icon-facebook" />
              </a>
              <a href="https://twitter.com/airacer_inc" target="_blank" rel="noreferrer">
                <img src="/imgs/svg/icon_Twitter.svg" alt="icon-twitter" />
              </a>

              <a href="https://www.instagram.com/airacer_inc/" target="_blank" rel="noreferrer">
                <img src="/imgs/svg/icon_Instagram.svg" alt="icon-instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/airacer-inc/"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/imgs/svg/icon_LinkedIn_.svg" alt="icon-linkedin" />
              </a>
            </SocialIcon>
          </Social>
        </Max>
        <Separator />
        <Max>
          <LegalText>
            {
              'Airacer Inc. (“Airacer”) acts as an air charter broker to arrange on-demand, single entity charter flights operated by air carriers that hold all required economic and safety authorizations from the U.S. Department of Transportation (“DOT”), the Federal Aviation Administration (“FAA”) and, as applicable, foreign civil aviation authorities (“CAAs”). Such carriers exercise operational control over all charter flights arranged through Airacer. Airacer does not own or operate any aircraft and is not a direct air carrier. Airacer additionally arranges aircraft management services for aircraft owners and lessees, provided by air carriers or other operators holding all required DOT, FAA, and foreign CAA authorizations. © 2024, Airacer Inc.'
            }
          </LegalText>
          <LegalInfo>
            <LegalInfoContent>{currentYear} Airacer Inc.</LegalInfoContent>
            <LegalInfoContent>Privacy and Legal Information</LegalInfoContent>
          </LegalInfo>
        </Max>
      </NewFooter>
      {activityState && (
        <SuccessfulState
          type={'foot-register'}
          couponsHandleCancel={() => {
            setState({
              activityState: false,
            });
          }}
        />
      )}
    </>
  );
};

export default ResponsiveFooter;
